var MinimalTheme = {};

jQuery(window).ready(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 5000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
});

jQuery(window).load(function(){  

  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });
   
});

jQuery(document).ready(function($){
    
  // force wide nav -->  
  
  // <-- end force wide nav
  
  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
     
  $("a.fancy").fancybox({
    padding: 0
  });
   
  
  /* Initialize zoom on main product image */
  var mainProductImage = $('.image.featured img');
  if (mainProductImage.size()) {
    var zoomedSrc = mainProductImage.attr('src').replace('_1024x1024', '');
    mainProductImage
    .wrap('<span style="display:inline-block;max-width:100%"></span>')
    .css('display', 'block')
    .parent()
    .zoom( { url: zoomedSrc } );
  }
  
  
  MinimalTheme.switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl)
      .attr('src', newSizedImageSrc)
      .parents('a')
      .attr('href', largestImage);
    
    $(mainImageDomEl)
      .parent()
      .trigger('zoom.destroy')
      .zoom( { url: largestImage } );
    
  };
  
  $('#product .thumbs a').click(function(e){
    e.preventDefault();
    var newSizedImageSrc = $(this).attr('href');
    var mainImageDomEl = $('.image.featured img')[0];
    MinimalTheme.switchImage(newSizedImageSrc, null, mainImageDomEl);
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
});

/* TOC */

function htmlTableOfContents (documentRef) {
    var documentRef = documentRef || document;
    var toc = documentRef.getElementById('toc');
    var headings = [].slice.call(documentRef.body.querySelectorAll('h2, h3'));
    headings.forEach(function (heading, index) {
        var anchor = documentRef.createElement('a');
        anchor.setAttribute('name', 'toc' + index);
        anchor.setAttribute('id', 'toc' + index);

        var link = documentRef.createElement('a');
        link.setAttribute('href', '#toc' + index);
        link.textContent = heading.textContent;

        var div = documentRef.createElement('div');
        div.setAttribute('class', heading.tagName.toLowerCase());

        div.appendChild(link);
        toc.appendChild(div);
        heading.parentNode.insertBefore(anchor, heading);
    });
}

     // ==========================================================================
        // AUTO H5 ACCORDION JAVASCRIPT
        // ==========================================================================
        
        document.addEventListener('DOMContentLoaded', function() {
            initializeAutoAccordions();
        });
        
        function initializeAutoAccordions(containerSelector = '.accordion-enabled') {
            // Find all containers that should have accordions
            const containers = document.querySelectorAll(containerSelector);
            
            containers.forEach(function(container) {
                processContainer(container);
            });
            
            // If no specific containers found, process the entire body
            if (containers.length === 0 && containerSelector === '.accordion-enabled') {
                // Fallback: process any container with H5 elements
                const h5Elements = document.querySelectorAll('h5');
                const processedContainers = new Set();
                
                h5Elements.forEach(function(h5) {
                    const container = h5.closest('div, section, article, main, aside') || document.body;
                    if (!processedContainers.has(container)) {
                        processedContainers.add(container);
                        processContainer(container);
                    }
                });
            }
        }
        
        function processContainer(container) {
            const h5Elements = container.querySelectorAll('h5');
            
            if (h5Elements.length === 0) {
                return; // No H5 elements to process
            }
            
            h5Elements.forEach(function(h5, index) {
                // Skip if already processed
                if (h5.classList.contains('auto-accordion-header')) {
                    return;
                }
                
                // Find all content between this H5 and the next H5 (or end of container)
                const contentElements = [];
                let nextElement = h5.nextElementSibling;
                
                while (nextElement && nextElement.tagName !== 'H5') {
                    contentElements.push(nextElement);
                    nextElement = nextElement.nextElementSibling;
                }
                
                // Only create accordion if there's content to wrap
                if (contentElements.length > 0) {
                    createAccordionFromElements(h5, contentElements);
                }
            });
        }
        
        function createAccordionFromElements(h5, contentElements) {
            // Add accordion classes and icon to H5
            h5.classList.add('auto-accordion-header');
            h5.setAttribute('tabindex', '0');
            h5.setAttribute('aria-expanded', 'false');
            
            // Add icon if it doesn't exist
            if (!h5.querySelector('.auto-accordion-icon')) {
                const iconContainer = document.createElement('span');
                iconContainer.innerHTML = `
                    <svg class="auto-accordion-icon" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                    </svg>
                `;
                h5.appendChild(iconContainer.firstElementChild);
            }
            
            // Create wrapper for content
            const contentWrapper = document.createElement('div');
            contentWrapper.classList.add('auto-accordion-content');
            contentWrapper.setAttribute('aria-hidden', 'true');
            
            // Move all content elements into the wrapper
            contentElements.forEach(function(element) {
                contentWrapper.appendChild(element);
            });
            
            // Insert wrapper after H5
            h5.parentNode.insertBefore(contentWrapper, h5.nextSibling);
            
            // Add event listeners
            h5.addEventListener('click', function() {
                toggleAutoAccordion(h5, contentWrapper);
            });
            
            h5.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleAutoAccordion(h5, contentWrapper);
                }
            });
        }
        
        function toggleAutoAccordion(header, content) {
            const isActive = header.classList.contains('active');
            
            if (isActive) {
                // Close accordion
                header.classList.remove('active');
                content.classList.remove('active');
                header.setAttribute('aria-expanded', 'false');
                content.setAttribute('aria-hidden', 'true');
                content.style.maxHeight = '0px';
                content.style.padding = '0';
            } else {
                // Close other accordions in the same container (optional)
                const container = header.closest('div, section, article, main') || document.body;
                const otherActiveHeaders = container.querySelectorAll('h5.auto-accordion-header.active');
                otherActiveHeaders.forEach(function(otherHeader) {
                    if (otherHeader !== header) {
                        const otherContent = otherHeader.nextElementSibling;
                        otherHeader.classList.remove('active');
                        if (otherContent && otherContent.classList.contains('auto-accordion-content')) {
                            otherContent.classList.remove('active');
                            otherContent.style.maxHeight = '0px';
                            otherContent.style.padding = '0';
                            otherContent.setAttribute('aria-hidden', 'true');
                        }
                        otherHeader.setAttribute('aria-expanded', 'false');
                    }
                });
                
                // Open accordion
                header.classList.add('active');
                content.classList.add('active');
                header.setAttribute('aria-expanded', 'true');
                content.setAttribute('aria-hidden', 'false');
                
                // Set padding and max-height for smooth animation
                content.style.padding = '1.5rem';
                content.style.maxHeight = content.scrollHeight + 30 + 'px'; // +30 for padding
                
                // Adjust max-height after transition
                setTimeout(function() {
                    if (content.classList.contains('active')) {
                        content.style.maxHeight = 'none';
                    }
                }, 300);
            }
            
            // Dispatch custom event
            const event = new CustomEvent('auto-accordion-toggle', {
                detail: {
                    header: header,
                    content: content,
                    isOpen: !isActive
                }
            });
            document.dispatchEvent(event);
        }
        
        // Utility functions for manual control
        window.initializeAutoAccordions = initializeAutoAccordions;
        
        window.openAutoAccordion = function(headerSelector) {
            const header = document.querySelector(headerSelector);
            if (header && !header.classList.contains('active')) {
                const content = header.nextElementSibling;
                if (content && content.classList.contains('auto-accordion-content')) {
                    toggleAutoAccordion(header, content);
                }
            }
        };
        
        window.closeAutoAccordion = function(headerSelector) {
            const header = document.querySelector(headerSelector);
            if (header && header.classList.contains('active')) {
                const content = header.nextElementSibling;
                if (content && content.classList.contains('auto-accordion-content')) {
                    toggleAutoAccordion(header, content);
                }
            }
        };
        
        window.closeAllAutoAccordions = function() {
            const activeHeaders = document.querySelectorAll('h5.auto-accordion-header.active');
            activeHeaders.forEach(function(header) {
                const content = header.nextElementSibling;
                if (content && content.classList.contains('auto-accordion-content')) {
                    toggleAutoAccordion(header, content);
                }
            });
        };
        
        // Re-initialize accordions if content is dynamically added
        window.reinitializeAutoAccordions = function(containerSelector) {
            initializeAutoAccordions(containerSelector || '.accordion-enabled');
        };